import React from "react";
import {
  TruckIcon,
  DocumentTextIcon,
  CalendarIcon,
  ShieldCheckIcon,
  ArrowPathIcon,
  ArrowUturnLeftIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import {
  TruckIcon as TruckIconSolid,
  DocumentTextIcon as DocumentTextIconSolid,
  CalendarIcon as CalendarIconSolid,
  ShieldCheckIcon as ShieldCheckIconSolid,
  ArrowPathIcon as ArrowPathIconSolid,
  ArrowUturnLeftIcon as ArrowUturnLeftIconSolid,
  ClockIcon as ClockIconSolid,
} from "@heroicons/react/24/solid";

import { SpeedIcon } from "./icons/Speed";

interface IIcon {
  name?: string | null;
  variant?: "outlined" | "solid";
  className?: string;
}

export function Icon({
  name,
  variant = "outlined",
  className = "",
}: IIcon): JSX.Element {
  switch (name) {
    case "truck":
      return variant === "outlined" ? (
        <TruckIcon className={className} />
      ) : (
        <TruckIconSolid className={className} />
      );
    case "calendar":
      return variant === "outlined" ? (
        <CalendarIcon className={className} />
      ) : (
        <CalendarIconSolid className={className} />
      );
    case "document-text":
      return variant === "outlined" ? (
        <DocumentTextIcon className={className} />
      ) : (
        <DocumentTextIconSolid className={className} />
      );
    case "shield-check":
      return variant === "outlined" ? (
        <ShieldCheckIcon className={className} />
      ) : (
        <ShieldCheckIconSolid className={className} />
      );
    case "arrow-path-rounded-square":
      return variant === "outlined" ? (
        <ArrowPathIcon className={className} />
      ) : (
        <ArrowPathIconSolid className={className} />
      );
    case "arrow-uturn-left":
      return variant === "outlined" ? (
        <ArrowUturnLeftIcon className={className} />
      ) : (
        <ArrowUturnLeftIconSolid className={className} />
      );
    case "clock":
      return variant === "outlined" ? (
        <ClockIcon className={className} />
      ) : (
        <ClockIconSolid className={className} />
      );
    case "speed":
      return <SpeedIcon className={className} />;
    default:
      return <></>;
  }
}
